import React from "react";
import PersonalFundraiserEdit from "./PersonalFundraiserEdit";
import PersonalFundraiserDetail from "./personalFundraiserDetail";
import PersonalFundraiserList from "./personalFundraiserList";
import { Route, Routes, } from "react-router-dom";

const PersonalFundraisers = () => {
   return (
         <Routes>
            <Route path="list" Component={PersonalFundraiserList}/>
            <Route path="details/:org_id" Component={PersonalFundraiserDetail}/>
            <Route path="create/:review_id/:org_id" Component={PersonalFundraiserEdit}/>
            <Route path="edit/:review_id/:org_id" Component={PersonalFundraiserEdit}/>
         </Routes>
   )
}
export default PersonalFundraisers 
 